import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import CommunicationModel from './communication';
import ContactDateModel from './contact-date';
import EventModel from './event';
import LineItemModel from './line-item';
import MailchimpEmailSyncModel from './mailchimp-email-sync';
import NoteModel from './note';
import PledgeModel from './pledge';
import ReviewItemModel from './review-item';
import TaskModel from './task';
import V2TaskModel from './v2-task';
import NewsletterContactModel from './newsletter-contact';
import ContactCampaignSummaryModel from './contact-campaign-summary';
import CampaignPledgeModel from './campaign-pledge';

export interface ContactLastGiftToOtherFund {
  contact_id: string;
  fund_id: string;
  fund_name: string;
  trans_date: string;
  amount: number;
}

export default class ContactDetailModel extends Model {
  @attr() lastGiftToOtherFunds!: ContactLastGiftToOtherFund[];
  @hasMany('line-item', { async: false, inverse: null })
  lines!: LineItemModel[];
  @hasMany('note', { async: false, inverse: null }) notes!: NoteModel[];
  @hasMany('event', { async: false, inverse: null }) events!: EventModel[];
  @hasMany('contact-date', { async: false, inverse: null })
  dates!: ContactDateModel[];
  @hasMany('pledge', { async: false, inverse: null }) pledges!: PledgeModel[];
  @hasMany('task', { async: false, inverse: null }) tasks!: TaskModel[];
  @hasMany('communication', { async: false, inverse: null })
  communications!: CommunicationModel[];
  @hasMany('v2-task', { async: false, inverse: null }) v2Tasks!: V2TaskModel[];
  @hasMany('review-item', { async: false, inverse: null })
  reviewItems!: ReviewItemModel[];
  @belongsTo('newsletter-contact', { async: false, inverse: null })
  newsletterContact?: NewsletterContactModel;
  @hasMany('mailchimp-email-sync', { async: false, inverse: null })
  mailchimpEmailSyncs!: MailchimpEmailSyncModel[];
  @hasMany('contact-campaign-summary', { async: false, inverse: null })
  campaignSummaries!: ContactCampaignSummaryModel[];
  @hasMany('campaign-pledge', { async: false, inverse: null })
  campaignPledges!: CampaignPledgeModel[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'contact-detail': ContactDetailModel;
  }
}
